import { TeamChatMessage } from '@/redux/types/teamChat'

export interface NegotiationMember {
  user_id: number
  email: string
  name: string
  status: string
  is_inviter: boolean
  role?: string
  profile_picture?: string
}

export interface Negotiation {
  negotiationId: string
  inviter: string
  members: NegotiationMember[]
  starttime: string
  round_number?: number
  member_count: number
  is_one_on_one: boolean
  negotiation_type: string
  end_time?: string
  phase_id?: number
  room_id?: string
}

export interface NegotiationState {
  isConnected: boolean
  error: string | null
  negotiations: Negotiation[]
  messages: NegotiationMessage[]
  isLoading: boolean
  pagination: {
    current_page: number
    total_pages: number
    has_next: boolean
    has_previous: boolean
    total_messages: number
  } | null
  loadingMoreMessages: boolean
  unreadByNegotiationId: Record<string, number>
  /** Per-negotiation "replying to" draft state, keyed by negotiation id. */
  replyTargets: Record<string, ReplyToSnippet>
}

/**
 * Denormalized quote carried on a reply message. The excerpt travels with the
 * message because the quoted original may predate a group member's join time.
 */
export interface ReplyToSnippet {
  id: string | number
  name: string
  excerpt: string
}

export interface BaseChatMessage {
  id?: string
  user: string
  message: string
  name?: string
  sender_role?: string
  user_profile_picture?: string
  entrytime?: string
}

export interface NegotiationMessage extends BaseChatMessage {
  type: 'negotiation'
  negotiationId: string
  phase_id?: number
  reply_to?: ReplyToSnippet | null
}

export type ChatMessage = TeamChatMessage | NegotiationMessage

export enum NegotiationType {
  PUBLIC_ROOM = 'PUBLIC_ROOM',
  PRIVATE_ROOM = 'PRIVATE_ROOM',
  GROUP_ROOM = 'GROUP_ROOM',
}
